import * as api from './api';
import * as factories from './factories';
import * as schema from './validation';
import * as transforms from './transforms';

export const AnswerModel = {
  ...api,
  ...factories,
  ...schema,
  ...transforms,
};
